import React from "react"
import { Box } from "theme-ui"

export const List = props => (
  <Box
    {...props}
    as="ul"
    sx={{
      display: "flex",
      justifyContent: "center",
      flexDirection: ["column", "column", "row"],
      alignItems: ["center"],
      listStyle: "none",
      padding: 0,
    }}
  />
)

export const Item = props => (
  <Box
    {...props}
    as="li"
    sx={{
      fontSize: 1,
      marginRight: 2,
      "&::after": {
        content: '"_"',
        marginLeft: "0.5rem",
        display: ["none", "none", "inline"],
      },
      "&:last-child": {
        marginRight: 0,
        "&::after": {
          display: "none",
        },
      },
    }}
  />
)
